// src/Views/HomePage.js
import React from 'react';
import './HomePage.css';
import TopFold from '../components/layout/TopFold';
import Footer from '../components/layout/Footer';
import NavbarPublic from '../components/layout/NavbarPublic';
import Banner from '../components/layout/Banner';
import FeatureSection1 from '../components/layout/FeatureSection1';
import HowItWorks from '../components/layout/HowItWorks';
import Badges from '../components/layout/Badges';
import AppComingSoon from "../components/layout/AppComingSoon";
import WhyStoriesWorkBetter from '../components/layout/WhyStoriesWorkBetter';
import LanguagesSection from "../components/layout/LanguagesSection";
import FounderStory from "../components/layout/FounderStory";
import ContactSection from "../components/layout/Contactsection";


const HomePage = () => {
    return (
        <div className="homepage">
            {/*<Banner /> */}
            <NavbarPublic />
            <TopFold />
            <LanguagesSection />    
            <FeatureSection1 />
            {/*<HowItWorks /> */}
            {/* <WhyStoriesWorkBetter /> */}
            <FounderStory />
            {/* <AppComingSoon /> */}
            {/* <ContactSection /> */}
            <Footer />
            {/* Additional homepage content can be added here */}
        </div>
    );
};

export default HomePage;